/**
 * "Billing & plans" overview — Billing section (ADR-0074).
 * Reconciled from billing.graphql (tiers, UC, subscriptions), ADR-0035
 * (usage-credit (UC) metered: Managed is bundled with no passthrough markup,
 * or BYOK), and the apps/web billing feature. Prices live on /pricing — this
 * section links, never restates them.
 */
import type { DocPageContent } from '../types';

export const BILLING_OVERVIEW_PAGE: DocPageContent = {
  slug: 'billing',
  titleKey: 'docs.billing.overview.title',
  descriptionKey: 'docs.billing.overview.description',
  blocks: [
    { kind: 'paragraph', textKey: 'docs.billing.overview.lead' },

    { kind: 'heading', level: 2, id: 'model', textKey: 'docs.billing.overview.model.heading' },
    { kind: 'paragraph', textKey: 'docs.billing.overview.model.body' },
    {
      kind: 'list',
      itemKeys: [
        'docs.billing.overview.model.item.workspace',
        'docs.billing.overview.model.item.usageCredits',
        'docs.billing.overview.model.item.route',
      ],
    },

    { kind: 'heading', level: 2, id: 'routes', textKey: 'docs.billing.overview.routes.heading' },
    { kind: 'paragraph', textKey: 'docs.billing.overview.routes.body' },
    {
      kind: 'definitions',
      items: [
        {
          termKey: 'docs.billing.overview.route.managed.term',
          descKey: 'docs.billing.overview.route.managed.desc',
        },
        {
          termKey: 'docs.billing.overview.route.byok.term',
          descKey: 'docs.billing.overview.route.byok.desc',
        },
      ],
    },
    {
      kind: 'callout',
      tone: 'tip',
      titleKey: 'docs.billing.overview.pricing.title',
      textKey: 'docs.billing.overview.pricing.body',
      links: {
        pricing: { target: { path: '/pricing' }, labelKey: 'docs.common.link.pricing' },
      },
    },

    { kind: 'heading', level: 2, id: 'explore', textKey: 'docs.billing.overview.explore.heading' },
    {
      kind: 'cardGrid',
      cards: [
        {
          titleKey: 'docs.billing.overview.card.plans.title',
          textKey: 'docs.billing.overview.card.plans.text',
          to: { docSlug: 'billing/plans' },
        },
        {
          titleKey: 'docs.billing.overview.card.usage.title',
          textKey: 'docs.billing.overview.card.usage.text',
          to: { docSlug: 'billing/usage' },
        },
        {
          titleKey: 'docs.billing.overview.card.subscription.title',
          textKey: 'docs.billing.overview.card.subscription.text',
          to: { docSlug: 'billing/subscription' },
        },
        {
          titleKey: 'docs.billing.overview.card.byok.title',
          textKey: 'docs.billing.overview.card.byok.text',
          to: { docSlug: 'billing/byok' },
        },
        {
          titleKey: 'docs.billing.overview.card.limits.title',
          textKey: 'docs.billing.overview.card.limits.text',
          to: { docSlug: 'billing/limits' },
        },
        {
          titleKey: 'docs.billing.overview.card.settings.title',
          textKey: 'docs.billing.overview.card.settings.text',
          to: { docSlug: 'dashboard/settings' },
        },
      ],
    },
  ],
};
